import { useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import type { IRoleUserForm } from '../model/role.schema'
import { rolesService } from '../services/roles.service'

/**
 * Lookup de roles del form de usuarios v1 (rama del flag `webAuthV2`). El listado
 * admin vive en use-roles-admin-query.ts y la variante v2 en use-roles-v2-lookup-query.ts.
 */
export const useRolesLookupQuery = (dependence: boolean = true) => {
  return useQuery<IRoleUserForm[]>({
    queryKey: queryKeys.roles.lookup(),
    queryFn: async () => {
      try {
        return await rolesService.getLookup()
      } catch (error) {
        console.log(error)
        toast.error(getErrorMessage(error))
        return []
      }
    },
    refetchOnWindowFocus: false,
    enabled: dependence
  })
}
